import { addRoute } from "routes";
import { Navigate } from "react-router-dom";
import { DashboardPage } from "./DashboardPage";
import { LibraryPage } from "./LibraryPage";
import { InitialSetupPage } from "./InitialSetupPage";
import { SettingsPage } from "./SettingsPage";
import { TeamSetupPage } from "./TeamSetupPage";
import { BackofficePage } from "./BackofficePage";
import { MyTeamsPage } from "./MyTeamsPage";
import { WorkspacePage } from "./WorkspacePage";
import { ToolsPage } from "./ToolsPage";
import { ActivityLogPage } from "./TasksPage";
import { MedicalPage } from "./MedicalPage";

addRoute("/", () => Navigate({ to: "/medical", replace: true }), { requiresAuth: true });
// addRoute("/", WorkspacePage, { requiresAuth: true });
addRoute("/library", LibraryPage, { requiresAuth: true });
addRoute("/tools/*", ToolsPage, { requiresAuth: true });
addRoute("/tasks", ActivityLogPage, { requiresAuth: true });
addRoute("/my-teams", MyTeamsPage, { requiresAuth: true });
addRoute("/settings/*", SettingsPage, { requiresAuth: true });
addRoute("/team-setup", TeamSetupPage, { requiresAuth: true });
// addRoute("/workspaces", WorkspacePage, { requiresAuth: true });
addRoute("/medical/*", MedicalPage, { requiresAuth: true });
addRoute("/backoffice/*", BackofficePage, { requiresAuth: true, minimumPermission: 1 });
